import router from '../router/index';

export default {
  install: function (Vue, options) {

   //调用：this.$el_alert('这是一条消息提示'); duration=0,则不会自动关闭
    Vue.prototype.$el_alert_time=function(str,duration) {
      //关闭其他message实例
      this.$message.closeAll();
      this.$message({
        message:str,
        duration:duration
      });
    }
	 //调用：this.$el_alert_type('这是一条消息提示','success'); 默认时间3000毫秒
	 Vue.prototype.$el_alert_type=function(str,type) {
		 //关闭其他message实例
     this.$message.closeAll();
     //type:success/warning/info/error    /成功消息/警告消息/普通消息/错误提示
     this.$message({
          message: str,
          type: type
        });
     }

    //判断登录状态及自动登录
    //调用： this.$autoLogin().then(()=>{
    //         //登录成功执行动作
    //       },()=>{
    //         //登录失败执行动作
    //       })
    Vue.prototype.$autoLogin=function() {
      return new Promise((resolve, reject)=>{
        //通过判断userId是否存在判断登录状态
        if(window.sessionStorage.id){
          //已登录
          resolve();
        }else{
          //未登录执行自动登录
          this.$api.post("/login/autoLogin",{}).then((response)=>{
            if(response.data.successFlag === 1){
              //放入userId
              window.sessionStorage.setItem("id",response.data.id);
              //放入用户角色
              window.sessionStorage.setItem("role",response.data.role);
              //放入邮箱
              window.sessionStorage.setItem("email",response.data.email);
              //放入个人名称
              window.sessionStorage.setItem("name",response.data.name);
              //放入个人头像地址
              window.sessionStorage.setItem("headImagePath",response.data.headImagePath);
              window.sessionStorage.setItem("loginName",response.data.loginName);
              //已登录
              resolve();
            }else{
              //登录失败
              reject();
            }
          })
        }
        }
      )
    }

    //第三方的登陆,或者绑定第三方账号时弹出小窗口
    Vue.prototype.open_third_window=function(url, width, height) {
      width = width || 600;
      height = height || 400;
      let left = (window.screen.width - width) / 2;
      let top = (window.screen.height - height) / 2;
      window.open(url, "_blank", "toolbar=yes, location=yes, directories=no, status=no, menubar=yes, scrollbars=yes, resizable=no, copyhistory=yes, left="+left+", top="+top+", width="+width+", height="+height);
    }

    //qq授权登陆
    Vue.prototype.qqLogin=function() {
      let qqAppId = this.global_.qq_appId; // qq的appid
      let qqAuthPath = this.global_.qq_redirectURI; // 回调地址
      let state = 'mdcollege'; // 防止CSRF攻击的随机参数，必传，登录成功之后会回传，最好后台自己生成然后校验合法性
      this.open_third_window(`https://graph.qq.com/oauth2.0/authorize?response_type=token-dongdu&client_id=${qqAppId}&redirect_uri=${encodeURIComponent(qqAuthPath)}&state=${state}`);
    }

    //微博授权登陆
    Vue.prototype.wbLogin=function() {
      let weiboAppId = this.global_.wb_appId;
      let weiboAuthPath = this.global_.wb_redirectURI;;
      this.open_third_window(`https://api.weibo.com/oauth2/authorize?client_id=${weiboAppId}&forcelogin=true&response_type=code&redirect_uri=${encodeURIComponent(weiboAuthPath)}`);
    }

    //微信授权登陆
    Vue.prototype.wxLogin=function() {
      let wxAppId = this.global_.wx_appId;
      let wxAuthPath = encodeURIComponent(this.global_.wx_redirectURI);
      console.log(wxAuthPath);
      let state = 'mdcollege'; // 防止CSRF攻击的随机参数，必传，登录成功之后会回传，最好后台自己生成然后校验合法性
      this.open_third_window(`https://open.weixin.qq.com/connect/qrconnect?appid=${wxAppId}&redirect_uri=${wxAuthPath}&response_type=code&scope=snsapi_login&state=${state}#wechat_redirect`,800,800);
    }
  }
}



// WEBPACK FOOTER //
// ./src/util/public.js